import MapSearch from 'components/MapSearchPage/MapSearchLayout';
import { getDefaults } from 'lib/enums/search';
import queryString from 'query-string';
import has from 'lodash/has';
import every from 'lodash/every';
import { wrapper } from 'pages/_app.page';
import { setSearchMeta } from 'store/search/searchActions';
import { sanitizeSearch } from 'lib/sanitize';
import isEqual from 'lodash/isEqual';
import authenticateUser from 'lib/user/authenticateUser';

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, query }) => {
  await authenticateUser(req.cookies, store.dispatch, store.getState());

  const defaults = getDefaults();
  const hasAllDefaultParams = every(
    Object.keys(defaults).map((defaultKey) => has(query, defaultKey)),
    Boolean,
  );

  if (!hasAllDefaultParams) {
    const queryParamsWithDefaults = {
      ...defaults,
      ...query,
    };
    const newQueryString = queryString.stringify(queryParamsWithDefaults);
    return {
      redirect: {
        permanent: false,
        destination: `/search/map?${newQueryString}`,
      },
    };
  }

  const sanitizedQuery = sanitizeSearch(query);
  const didSanitize = !isEqual(query, sanitizedQuery);

  if (didSanitize) {
    const newQueryString = queryString.stringify(sanitizedQuery);
    return {
      redirect: {
        permanent: false,
        destination: `/search/map?${newQueryString}`,
      },
    };
  }

  store.dispatch(setSearchMeta({ meta: { query } }));

  return {
    props: {},
  };
});

export default MapSearch;
